import {ObjectType} from './object-type.enum';

/**
 * Class containing info about route, used to create statistics (most visited object details)
 */
export class LogObject {

  /**
   * Default constructor.
   * @param {number} id
   * @param {ObjectType} objectType
   * @param {string} httpHeaders - for now this property is always empty
   * @param {string} source
   */
  constructor(public objectId?: string, public objectType?: ObjectType, public httpHeaders?: string, public source?: string) {
  }

}
